import { coreAPI } from "../../axios";

export const actions = {
  SendPhoneCode(context, data) {
    return coreAPI.post(`Verification/SendCode/${data.type}/${data.id}`);
  },
  SendEmailCode(context, data) {
    return coreAPI.post(`Verification/SendEmailCode/${data.type}/${data.id}`);
  },
  verifyCode(context, data) {
    return coreAPI.post("Verification/VerifyCode", data);
  },
};
